export const ASTexceptions: Record<number, string> = {
    101: "QR Not Valid",
    102: "Instrument Has Been Assigned to Another QR.Please contact Service Admin.",
    103: "Instrument Not Available",
    104: "Please select an instrument.",
};